import Resource from '@/services/resources/common';

export default class GeometryLineResource extends Resource {
  constructor(entrypoint = '/lines', alias = 'GeometryLine') {
    super(entrypoint, alias);
  }
}
